/**
 * Single source-of-truth for the Toothmatrix build version.
 *
 * Bumped at the close of every shipped iteration (see /app/memory/PRD.md).
 * Surfaced in:
 *   - The public Compliance page (footer line + JSON-LD `softwareVersion`)
 *   - The main site footer (every page)
 *   - Optional: an /api/version backend endpoint (TBD)
 *
 * Format: semantic-ish — major.minor.iteration. We've kept the same major
 * since the multi-tenant SaaS pivot ("Toothmatrix"), so the iteration count
 * is the meaningful number — it represents the count of audited, tested
 * iterations shipped to production since v1.0.0.
 */
export const VERSION = {
    /** Semver-like build identifier. */
    version: "1.0.82",
    /** Iteration counter — every entry in PRD.md = +1. */
    iteration: 82,
    /** Total production releases ever shipped (matches `iteration` while we stay on v1.x). */
    total_releases: 82,
    /** Most-recent release ship date (ISO-8601). */
    released_at: "2026-06-28",
    /** Released-from codename. */
    codename: "Admin tab visibility fix + Self-service forgot password",
};

/** Compact human label, e.g. "v1.0.52 · 52 releases · 2026-02-11". */
export const versionLabel = () =>
    `v${VERSION.version} · ${VERSION.total_releases} releases · ${VERSION.released_at}`;
